import React, { useState } from 'react';
import { ModalWindow } from 'view/molecules/ModalWindow';
import { ProvideAccessForm, ProvideAccessNotice } from './components';

type Props = {
  closeHandler: () => void;
  modalRef?: React.Ref<HTMLDivElement>;
};

export const ProvideAccessModal = ({ closeHandler, modalRef }: Props) => {
  const [isOnForm, setIsOnForm] = useState(true);
  const [sharedEmail, setSharedEmail] = useState<string>();

  return (
    <ModalWindow ref={modalRef} hideWindow={closeHandler}>
      {isOnForm ? (
        <ProvideAccessForm
          setSharedEmail={setSharedEmail}
          afterSubmit={() => setIsOnForm(false)}
        />
      ) : (
        <ProvideAccessNotice email={sharedEmail} onOk={closeHandler} />
      )}
    </ModalWindow>
  );
};
